// extracted by mini-css-extract-plugin
export default {"pointsSec":"Points_pointsSec__qOxTP","points":"Points_points__smsrf","cell":"Points_cell__pMedy","iconWrpr":"Points_iconWrpr__A+g-C","ftr":"Points_ftr__ansZr"};